import { SavedDataInterface } from './useSaveSet';
import { useAtomValue } from 'jotai';
import { get } from 'lodash';
import { useGetSave } from './atoms';

function useGetDataToBeSaved({ pageMeta }): { dataToBeSaved: SavedDataInterface } {
  const pageKey = get(pageMeta, ['page', 'key'], '');
  const { saveData: dataToBeSaved } = useGetSave({ pageKey });
  return { dataToBeSaved };
}

export default useGetDataToBeSaved;
